(($) => {
  "use strict";
  console.log("header js");

  // Animate header on page load
  if (typeof gsap === 'undefined') return;
  
  gsap.from("#hoverPreviewImageMenu1 #hoverPreviewImageMenu2", {
    opacity: 0,
    duration: 0.35,
    y: -20,
    ease: "Power1.easeInOut",
  });

  //Header Menu 1 Logic to get the images
  // 1. Mouse Enter handler on one child…
  $(".header-menu-1").on("mouseenter", function () {
    // 2. Jump straight to the sibling that has the value you need
    const imageMenuLink1 = $(this) // the clicked <button>
      .siblings(".menu-hover-image") // its <span class="price"> sibling
      .data("image-url"); // read data-price

    if (imageMenuLink1) {
      const $img = $("#hoverPreviewImageMenu1");
      $img.attr("src", imageMenuLink1).addClass("active");

      gsap.fromTo($img, { opacity: 0, y: 0 }, { opacity: 1, y: 0 });
    }
  });

  $(".nav-link").on("mouseleave", function () {
    gsap.to("#hoverPreviewImageMenu1", {
      opacity: 0,
      onComplete: () => {
        $("#hoverPreviewImageMenu1").removeClass("active");
      },
    });
  });

  //Header Menu 2 Logic to get the images
  // 1. Mouse Enter handler on one child…
  $(".header-menu-2").on("mouseenter", function () {
    // 2. Jump straight to the sibling that has the value you need
    const imageMenuLink2 = $(this) // the clicked <button>
      .siblings(".menu-hover-image") // its <span class="price"> sibling
      .data("image-url"); // read data-price

    if (imageMenuLink2) {
      const $img = $("#hoverPreviewImageMenu2");
      $img.attr("src", imageMenuLink2).addClass("active");

      gsap.fromTo($img, { opacity: 0, y: 0 }, { opacity: 1, y: 0 });
    }
  });

  $(".nav-link").on("mouseleave", function () {
    gsap.to("#hoverPreviewImageMenu2", {
      opacity: 0,
      onComplete: () => {
        $("#hoverPreviewImageMenu2").removeClass("active");
      },
    });
  });


  // Mobile menu scroll lock and viewport height management
  function toggleBodyScroll(shouldLock) {
    if (window.innerWidth < 768) {
      if (shouldLock) {
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
      }
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    var mainMenuEl = document.getElementById("mainMenu");

    var bsCollapse = new bootstrap.Collapse(mainMenuEl, { toggle: false });

    // Handle menu show/hide events
    mainMenuEl.addEventListener('shown.bs.collapse', function () {
      toggleBodyScroll(true);
    });

    mainMenuEl.addEventListener('hidden.bs.collapse', function () {
      toggleBodyScroll(false);
    });

    // Handle window resize
    window.addEventListener('resize', function() {
      if (mainMenuEl.classList.contains('show')) {
      }
      // Unlock scroll if viewport becomes larger than 768px
      if (window.innerWidth >= 768) {
        toggleBodyScroll(false);
      }
    });

    document.addEventListener("click", function (event) {
      var target = event.target;

      var isMenuOpen = mainMenuEl.classList.contains("show");
      if (!isMenuOpen) {
        return; 
      }

      
      var clickedInsideMenu = mainMenuEl.contains(target);
      var navbarToggler = document.querySelector(
        '.navbar-toggler[data-bs-target="#mainMenu"]'
      );
      var clickedOnToggler = navbarToggler.contains(target);

      if (!clickedInsideMenu && !clickedOnToggler) {
        bsCollapse.hide();
      }
    });
  });
})(jQuery);
